export const ADD_ADDRESS_TO_ADDRESS_LIST = 'ADD_ADDRESS_TO_ADDRESS_LIST';
export const ADD_ADDRESSES_TO_ADDRESS_LIST = 'ADD_ADDRESSES_TO_ADDRESS_LIST';
export const CHANGE_ADDRESS_TYPE = 'ADDRESS_TYPE';
export const CLEAR_ADDRESS_LIST = 'CLEAR_ADDRESS_LIST';
export const GENERIC_API_ERROR = 'GENERIC_API_ERROR';
export const GET_ADDRESS_LIST = 'GET_ADDRESS_LIST';
export const GET_ADDRESS_LIST_GR = 'GET_ADDRESS_LIST_GR';
export const GET_ADDRESS_LIST_RESPONDED = 'GET_ADDRESS_LIST_RESPONDED';
export const HANDLE_INTERNATIONAL_SHIPPING_ERROR = 'HANDLE_INTERNATIONAL_SHIPPING_ERROR';
export const IS_SHOWING_SHIPPING_ADDRESS = 'IS_SHOWING_SHIPPING_ADDRESS';
export const NO_ACTION = 'NO_ACTION';
export const SERVICE_LEVELS_REQUESTED = 'SERVICE_LEVELS_REQUESTED';
export const SET_ADDRESS_STANDARDIZATION = 'SET_ADDRESS_STANDARDIZATION';
export const SET_DEFAULT_ADDRESS = 'SET_DEFAULT_ADDRESS';
export const SET_ORDER_SHIPPING_METHODS = 'SET_ORDER_SHIPPING_METHODS';
export const SET_SELECTED_ADDRESS = 'SET_SELECTED_ADDRESS';
export const SET_SERVICE_ERROR = 'SET_SERVICE_ERROR';
export const SHOW_HIDE_MILITARY_ADDRESS_FIELDS = 'SHOW_HIDE_MILITARY_ADDRESS_FIELDS';
export const SUBMIT_SHIPPING_ADDRESS_FORM = 'SUBMIT_SHIPPING_ADDRESS_FORM';
export const SUBMIT_SHIPPING_ADDRESS_FORM_FAILURE = 'SUBMIT_SHIPPING_ADDRESS_FORM_FAILURE';
export const SUBMIT_SHIPPING_ADDRESS_FORM_SUCCESS = 'SUBMIT_SHIPPING_ADDRESS_FORM_SUCCESS';
